import { render } from "./PartRecommendations.vue?vue&type=template&id=365a3544"
import script from "./PartRecommendations.vue?vue&type=script&lang=js"
export * from "./PartRecommendations.vue?vue&type=script&lang=js"
script.render = render

export default script